<template>
  <div class="form" :class="{ 'form-loading': isLoading }">
    <input-group>
      <input-wrapper>
        <label>Idade <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          type="number"
          class="flexible-input"
          v-model="age"
          :disabled="!isEdit"
          min="0"
        />
      </input-wrapper>
      <input-wrapper>
        <label>Gênero <span style="color: red; font-size: 20px">*</span></label>
        <el-select
          placeholder="Selecione"
          v-model="gender"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in genderOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper>
        <label>Cor <span style="color: red; font-size: 20px">*</span></label>
        <el-select
          placeholder="Selecione"
          v-model="color"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in colorOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Peso <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          type="number"
          class="flexible-input"
          v-model="weight"
          :disabled="!isEdit"
          min="0"
        />
      </input-wrapper>
      <input-wrapper>
        <label>Altura <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          type="number"
          class="flexible-input"
          v-model="height"
          :disabled="!isEdit"
          min="0"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Diagnóstico <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="diag"
          :disabled="!isEdit"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in diagOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Idade no início dos sintomas</label>
        <el-input
          type="number"
          class="flexible-input"
          v-model="yearStartSint"
          :disabled="!isEdit"
          min="0"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Idade no momento do diagnóstico
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          type="number"
          class="flexible-input"
          v-model="yearDiag"
          :disabled="!isEdit"
          min="0"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Localização segundo Montreal*
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          class="flexible-input"
          v-model="locationMontreal"
          min="0"
          :disabled="diag !== 1 || !isEdit"
        />
      </input-wrapper>
    </input-group>

    <input-group>
      <input-wrapper>
        <label
          >Comportamento segundo Montreal*
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          class="flexible-input"
          v-model="behaviorMontreal"
          min="0"
          :disabled="diag !== 1 || !isEdit"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Extensão* <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          class="flexible-input"
          v-model="extension"
          min="0"
          :disabled="diag === 1 || !isEdit"
        />
      </input-wrapper>
    </input-group>

    <input-group>
      <input-wrapper>
        <label
          >Principais sinais e sintomas de apresentação
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="mainSymptoms"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in mainSymptomsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper v-if="mainSymptoms === 6">
        <label>Quais? <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          class="flexible-input"
          v-model="mainSymptomsDescription"
          min="0"
          :disabled="!isEdit"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Necessidade de corticoide ao diagnóstico
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="needCorticoide"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in needCorticoideOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Já necessitou de cirurgia para a Doença inflamatória intestinal?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="neededSurgery"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in neededSurgeryOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper v-if="neededSurgery === 1">
        <label>Quais? <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          v-model="neededSurgeryDescription"
          :disabled="!isEdit"
          type="text"
          min="0"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Manifestações extra-intestinais?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="intestinalManifestations"
          :disabled="!isEdit"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in intestinalManifestationsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper v-if="intestinalManifestations === 1">
        <label>Quais? <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          v-model="intestinalManifestationsDescription"
          :disabled="!isEdit"
          type="text"
          min="0"
        />
      </input-wrapper>
    </input-group>
    <h1 class="title">Quais os tratamentos já realizados?</h1>
    <span class="line"></span>
    <input-group>
      <input-wrapper>
        <label
          >Medicação <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          v-model="selectedMedication"
          :disabled="!isEdit"
          placeholder="Selecione a medicação"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in medicationOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper>
        <label
          >Ano de início
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="startYear"
          :disabled="!isEdit"
          type="number"
          placeholder="Digite o ano de início"
          min="1900"
          :max="new Date().getFullYear()"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Ano de término
          <span style="color: red; font-size: 20px">*</span>
        </label>
        <el-input
          v-model="endYear"
          :disabled="!isEdit"
          type="number"
          placeholder="Digite o ano de término"
          min="1900"
          :max="new Date().getFullYear()"
        />
      </input-wrapper>
    </input-group>

    <input-group>
      <input-wrapper>
        <label
          >Respondeu inicialmente ao tratamento?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          v-model="initialResponse"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper>
        <label
          >Houve interrupção do tratamento?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          v-model="treatmentInterrupted"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper v-if="treatmentInterrupted === 1">
        <label
          >Motivo da interrupção
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          v-model="interruptionReason"
          :disabled="!isEdit"
          placeholder="Selecione o motivo"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in interruptionReasonOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>

    <el-button
      @click="addTreatment"
      type="primary"
      :disabled="!canAddTreatment"
      style="margin-top: 20px;"
    >
      Adicionar Tratamento
    </el-button>

    <el-table
      :data="treatments"
      style="width: 100%; margin-top: 20px; border: 1px solid #dcdfe6; border-radius: 4px; margin-bottom: 20px;"
    >
      <el-table-column prop="medication" label="Medicação" />
      <el-table-column prop="startYear" label="Ano de início" />
      <el-table-column prop="endYear" label="Ano de término" />
      <el-table-column prop="initialResponse" label="Resposta inicial" />
      <el-table-column
        prop="treatmentInterrupted"
        label="Tratamento interrompido"
      />
      <el-table-column
        prop="interruptionReason"
        label="Motivo da interrupção"
      />
      <el-table-column>
        <template #default="scope">
          <el-button
            @click="removeTreatment(scope.$index)"
            type="danger"
            size="small"
          >
            Remover
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <input-group>
      <input-wrapper>
        <label
          >Tratamento atual?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="currentTreatment"
          :disabled="!isEdit"
          type="text"
          placeholder="Digite o tratamento atual"
        />
      </input-wrapper>
      <input-wrapper>
        <label
          >Comorbidades?
          <span style="color: red; font-size: 20px">*</span>
        </label>
        <el-select
          v-model="hasComorbidities"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper v-if="hasComorbidities === 1">
        <label>Quais?</label>
        <el-input
          v-model="comorbidities"
          :disabled="!isEdit"
          type="text"
          placeholder="Digite as comorbidades"
        />
      </input-wrapper>
    </input-group>

    <input-group>
      <input-wrapper>
        <label
          >Alergias medicamentosas?
          <span style="color: red; font-size: 20px">*</span>
        </label>
        <el-select
          v-model="hasMedicationAllergies"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper>
        <label
          >Qual principal motivo da consulta?
          <span style="color: red; font-size: 20px">*</span>
        </label>
        <el-input
          v-model="mainConsultationReason"
          :disabled="!isEdit"
          type="text"
          placeholder="Digite o motivo principal da consulta"
        />
      </input-wrapper>
    </input-group>
    <h1 class="title">Exames complementares ao diagnóstico</h1>
    <span class="line"></span>
    <input-group>
      <input-wrapper>
        <label>Proteína C reativa?</label>
        <el-select
          v-model="hasProteinaCReativa"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
      <input-wrapper>
        <label>Calprotectina fecal?</label>
        <el-select
          v-model="hasCalprotectinaFecal"
          :disabled="!isEdit"
          placeholder="Selecione"
          size="large"
          filterable
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Primeira colonoscopia está disponível?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="firstColonoscopy"
          :disabled="!isEdit"
          size="large"
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 1">
      <input-wrapper class="clinical-case-upload">
        <label>Upload da primeira colonoscopia</label>
        <el-upload
          v-model="colonoscopyFileList"
          :disabled="!isEdit"
          class="upload-demo"
          :auto-upload="false"
          @change="(file) => handleFileImg(file, 'colonoscopy')"
          :show-file-list="false"
        >
          <template #trigger>
            <el-input type="text" :disabled="!isEdit" :suffix-icon="iconImg" />
          </template>
        </el-upload>

        <div v-if="getColonoscopyFiles.length > 0">
          <div
            class="filepath"
            v-for="file in getColonoscopyFiles"
            :key="file.id"
          >
            <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
            <p @click="handleDownload(file.id, file.fileName)" class="filename">
              {{ file.fileName }}
            </p>
          </div>
        </div>
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 1">
      <input-wrapper>
        <label
          >Data da primeira colonoscopia
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          type="text"
          :disabled="!isEdit"
          placeholder="Data _/_/__"
          class="flexible-input"
          v-model="colonoscopyDate"
          v-mask="'##/##/####'"
        />
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 1">
      <input-wrapper>
        <label
          >Quais os achados?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="colonoscopyFindings"
          :disabled="!isEdit"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
        />
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 2">
      <input-wrapper class="clinical-case-upload">
        <label>Upload da colonoscopia mais antiga</label>
        <el-upload
          v-model="oldestColonoscopyFileList"
          :disabled="!isEdit"
          class="upload-demo"
          :auto-upload="false"
          @change="(file) => handleFileImg(file, 'oldest_colonoscopy')"
          :show-file-list="false"
        >
          <template #trigger>
            <el-input type="text" :disabled="!isEdit" :suffix-icon="iconImg" />
          </template>
        </el-upload>

        <div v-if="getOldestColonoscopyFiles.length > 0">
          <div
            class="filepath"
            v-for="file in getOldestColonoscopyFiles"
            :key="file.id"
          >
            <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
            <p @click="handleDownload(file.id, file.fileName)" class="filename">
              {{ file.fileName }}
            </p>
          </div>
        </div>
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 2">
      <input-wrapper>
        <label
          >Data da colonoscopia mais antiga
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          type="text"
          :disabled="!isEdit"
          placeholder="Data _/_/__"
          class="flexible-input"
          v-model="oldestColonoscopyDate"
          v-mask="'##/##/####'"
        />
      </input-wrapper>
    </input-group>

    <input-group v-if="firstColonoscopy === 2">
      <input-wrapper>
        <label
          >Quais os achados?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="oldestColonoscopyFindings"
          :disabled="!isEdit"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Colonoscopia mais recente está disponível?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="recentColonoscopy"
          :disabled="!isEdit"
          size="large"
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>

    <input-group v-if="recentColonoscopy === 1">
      <input-wrapper class="clinical-case-upload">
        <label>Upload da colonoscopia mais recente</label>
        <el-upload
          v-model="recentColonoscopyFileList"
          :disabled="!isEdit"
          class="upload-demo"
          :auto-upload="false"
          @change="(file) => handleFileImg(file, 'recent_colonoscopy')"
          :show-file-list="false"
        >
          <template #trigger>
            <el-input type="text" :disabled="!isEdit" :suffix-icon="iconImg" />
          </template>
        </el-upload>

        <div v-if="getRecentColonoscopyFiles.length > 0">
          <div
            class="filepath"
            v-for="file in getRecentColonoscopyFiles"
            :key="file.id"
          >
            <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
            <p @click="handleDownload(file.id, file.fileName)" class="filename">
              {{ file.fileName }}
            </p>
          </div>
        </div>
      </input-wrapper>
    </input-group>

    <input-group v-if="recentColonoscopy === 1">
      <input-wrapper>
        <label
          >Data da colonoscopia mais recente
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          type="text"
          :disabled="!isEdit"
          placeholder="Data _/_/__"
          class="flexible-input"
          v-model="recentColonoscopyDate"
          v-mask="'##/##/####'"
        />
      </input-wrapper>
    </input-group>

    <input-group v-if="recentColonoscopy === 1">
      <input-wrapper>
        <label
          >Quais os achados?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="recentColonoscopyFindings"
          :disabled="!isEdit"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
        />
      </input-wrapper>
    </input-group>

    <input-group>
      <input-wrapper>
        <label>Exame de imagem?</label>
        <el-select
          placeholder="Selecione"
          v-model="imageExamSelect"
          :disabled="!isEdit"
          size="large"
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <input-group v-if="imageExamSelect === 1">
      <input-wrapper>
        <label
          >Nome do exame
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          placeholder="Selecione"
          v-model="nameExam"
          :disabled="!isEdit"
          size="large"
          clearable
        >
        </el-input>
      </input-wrapper>
    </input-group>
    <input-group v-if="imageExamSelect === 1">
      <input-wrapper class="clinical-case-upload">
        <label>Upload do exame</label>
        <el-upload
          v-model="imageExamFile"
          :disabled="!isEdit"
          class="upload-demo"
          :auto-upload="false"
          @change="(file) => handleFileImg(file, 'image_exam')"
          :show-file-list="false"
        >
          <template #trigger>
            <el-input type="text" :disabled="!isEdit" :suffix-icon="iconImg" />
          </template>
        </el-upload>

        <div v-if="getImageExamFiles.length > 0">
          <div
            class="filepath"
            v-for="file in getImageExamFiles"
            :key="file.id"
          >
            <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
            <p @click="handleDownload(file.id, file.fileName)" class="filename">
              {{ file.fileName }}
            </p>
          </div>
        </div>
      </input-wrapper>
    </input-group>
    <input-group v-if="imageExamSelect === 1">
      <input-wrapper>
        <label
          >Data do exame
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          type="text"
          :disabled="!isEdit"
          placeholder="Data _/_/__"
          class="flexible-input"
          v-model="imageExamDate"
          v-mask="'##/##/####'"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Endoscopia Digestiva Alta?</label>
        <el-select
          placeholder="Selecione"
          v-model="endoDigestiveHigh"
          :disabled="!isEdit"
          size="large"
          clearable
        >
          <el-option
            v-for="item in yesNoOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </input-wrapper>
    </input-group>
    <h1 class="title">Atividade atual da doença.</h1>
    <h2>Exames complementares atuais</h2>
    <table class="exam-table">
      <tr>
        <th>Data</th>
        <th>
          <input type="text" :disabled="!isEdit" v-model="examDates[0]" />
        </th>
        <th>
          <input type="text" :disabled="!isEdit" v-model="examDates[1]" />
        </th>
        <th>
          <input type="text" :disabled="!isEdit" v-model="examDates[2]" />
        </th>
        <th>
          <input type="text" :disabled="!isEdit" v-model="examDates[3]" />
        </th>
      </tr>
      <tr>
        <td>Hb</td>
        <td><input type="text" :disabled="!isEdit" v-model="examHb[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examHb[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examHb[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examHb[3]" /></td>
      </tr>
      <tr>
        <td>VCM</td>
        <td><input type="text" :disabled="!isEdit" v-model="examVcm[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examVcm[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examVcm[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examVcm[3]" /></td>
      </tr>
      <tr>
        <td>RDW</td>
        <td><input type="text" :disabled="!isEdit" v-model="examRdw[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examRdw[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examRdw[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examRdw[3]" /></td>
      </tr>
      <tr>
        <td>Leucócitos</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLeucocitos[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLeucocitos[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLeucocitos[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLeucocitos[3]" />
        </td>
      </tr>
      <tr>
        <td>Neutrófilos</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examNeutrofilos[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examNeutrofilos[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examNeutrofilos[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examNeutrofilos[3]" />
        </td>
      </tr>
      <tr>
        <td>Linfócitos</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLinfocitos[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLinfocitos[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLinfocitos[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examLinfocitos[3]" />
        </td>
      </tr>
      <tr>
        <td>Eosinófilos</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examEosinofilos[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examEosinofilos[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examEosinofilos[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examEosinofilos[3]" />
        </td>
      </tr>
      <tr>
        <td>Plaquetas</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examPlaquetas[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examPlaquetas[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examPlaquetas[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examPlaquetas[3]" />
        </td>
      </tr>
      <tr>
        <td>Proteína C Reativa</td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examProteinaCReativa[0]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examProteinaCReativa[1]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examProteinaCReativa[2]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examProteinaCReativa[3]"
          />
        </td>
      </tr>
      <tr>
        <td>TGO</td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgo[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgo[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgo[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgo[3]" /></td>
      </tr>
      <tr>
        <td>TGP</td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgp[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgp[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgp[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examTgp[3]" /></td>
      </tr>
      <tr>
        <td>GGT</td>
        <td><input type="text" :disabled="!isEdit" v-model="examGgt[0]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examGgt[1]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examGgt[2]" /></td>
        <td><input type="text" :disabled="!isEdit" v-model="examGgt[3]" /></td>
      </tr>
      <tr>
        <td>Calprotectina Fecal</td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examCalprotectinaFecal[0]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examCalprotectinaFecal[1]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examCalprotectinaFecal[2]"
          />
        </td>
        <td>
          <input
            type="text"
            :disabled="!isEdit"
            v-model="examCalprotectinaFecal[3]"
          />
        </td>
      </tr>
      <tr>
        <td>Creatinina</td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examCreatinina[0]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examCreatinina[1]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examCreatinina[2]" />
        </td>
        <td>
          <input type="text" :disabled="!isEdit" v-model="examCreatinina[3]" />
        </td>
      </tr>
    </table>

    <h1 class="title">Observações Adicionais</h1>
    <textarea
      id="observacoes"
      name="observacoes"
      rows="10"
      v-model="observacoes"
      :disabled="!isEdit"
      placeholder="Digite suas observações adicionais aqui..."
    ></textarea>
    <div v-if="isEdit" class="button-container">
      <el-button class="send" type="primary" @click="salvarFormulario"
        >Salvar</el-button
      >
      <el-button
        class="send"
        type="primary"
        :disabled="handleEnabledSubmit"
        @click="handleActiveVoucher"
        >Submeter para avaliação</el-button
      >
    </div>
    <div class="classification-buttons">
      <button class="classification-btn" data-modal="montreal">
        Classificação de Montreal
        <el-icon><Document /></el-icon>
      </button>
      <button class="classification-btn" data-modal="harvey-bradshaw">
        Índice de Harvey-Bradshaw
        <el-icon><Document /></el-icon>
      </button>
      <button class="classification-btn" data-modal="mayo">
        Escore da Clínica Mayo
        <el-icon><Document /></el-icon>
      </button>
    </div>
    <!-- Modais -->
    <div id="montrealModal" class="modal">
      <div class="modal-content">
        <span class="close">&times;</span>
        <h2>Classificação de Montreal</h2>
        <!-- Conteúdo da modal -->
      </div>
    </div>

    <div id="harveyBradshawModal" class="modal">
      <div class="modal-content">
        <span class="close">&times;</span>
        <h2>Índice de Harvey-Bradshaw</h2>
        <!-- Conteúdo da modal -->
      </div>
    </div>

    <div id="mayoModal" class="modal">
      <div class="modal-content">
        <span class="close">&times;</span>
        <h2>Escore da Clínica Mayo</h2>
        <!-- Conteúdo da modal -->
      </div>
    </div>
  </div>
</template>

<script>
import { PictureFilled, Document } from '@element-plus/icons-vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ChronForm',
  components: {
    PictureFilled,
    Document
  },
  props: {
    voucherData: {
      type: Object,
      required: true
    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      isFieldsDisabled: false,
      examDates: ['', '', '', ''],
      examHb: ['', '', '', ''],
      examVcm: ['', '', '', ''],
      examRdw: ['', '', '', ''],
      examLeucocitos: ['', '', '', ''],
      examNeutrofilos: ['', '', '', ''],
      examLinfocitos: ['', '', '', ''],
      examEosinofilos: ['', '', '', ''],
      examPlaquetas: ['', '', '', ''],
      examProteinaCReativa: ['', '', '', ''],
      examTgo: ['', '', '', ''],
      examTgp: ['', '', '', ''],
      examGgt: ['', '', '', ''],
      examCalprotectinaFecal: ['', '', '', ''],
      examCreatinina: ['', '', '', ''],
      observacoes: '',
      colonoscopyFiles: [],
      recentColonoscopy: null,
      recentColonoscopyFileList: [],
      recentColonoscopyDate: null,
      recentColonoscopyFindings: null,
      oldestColonoscopyFileList: [],
      oldestColonoscopyDate: null,
      oldestColonoscopyFindings: null,
      iconImg: PictureFilled,
      colonoscopyFileList: [],
      selectedColonoscopyFile: {},
      imageExamSelect: null,
      imageExamFile: null,
      nameExam: null,
      age: null,
      imageExamDate: null,
      endoDigestiveHigh: null,
      gender: null,
      color: null,
      weight: null,
      height: null,
      diag: null,
      locationMontreal: null,
      yearStartSint: null,
      yearDiag: null,
      needCorticoide: null,
      neededSurgery: null,
      intestinalManifestations: null,
      intestinalManifestationsDescription: null,
      mainSymptomsDescription: null,
      mainSymptoms: null,
      behaviorMontreal: null,
      extension: null,
      neededSurgeryDescription: null,
      selectedMedication: null,
      startYear: null,
      endYear: null,
      initialResponse: null,
      treatmentInterrupted: null,
      interruptionReason: null,
      treatments: [],
      currentTreatment: '',
      hasComorbidities: null,
      comorbidities: '',
      hasMedicationAllergies: null,
      mainConsultationReason: '',
      hasProteinaCReativa: null,
      hasCalprotectinaFecal: null,
      firstColonoscopy: null,
      colonoscopyDate: null,
      colonoscopyFindings: null,
      genderOptions: [
        { id: 1, name: 'Masculino' },
        { id: 2, name: 'Feminino' }
      ],
      colorOptions: [
        { id: 1, name: 'Branca' },
        { id: 2, name: 'Preta' },
        { id: 3, name: 'Parda' },
        { id: 4, name: 'Amarela' },
        { id: 5, name: 'Indígena' }
      ],
      diagOptions: [
        { id: 1, name: 'Doença de Crohn' },
        { id: 2, name: 'Retocolite ulcerativa' },
        { id: 3, name: 'Colite não classificada' }
      ],
      needCorticoideOptions: [
        {
          id: 1,
          name: 'Sim'
        },
        {
          id: 2,
          name: 'Não'
        }
      ],
      neededSurgeryOptions: [
        {
          id: 1,
          name: 'Sim'
        },
        {
          id: 2,
          name: 'Não'
        }
      ],
      intestinalManifestationsOptions: [
        {
          id: 1,
          name: 'Sim'
        },
        {
          id: 2,
          name: 'Não'
        }
      ],
      mainSymptomsOptions: [
        { id: 1, name: 'Diarreia' },
        { id: 2, name: 'Dor abdominal' },
        { id: 3, name: 'Sangramento nas fezes' },
        { id: 4, name: 'Perda de peso' },
        { id: 5, name: 'Anemia' },
        { id: 6, name: 'Outros' }
      ],
      medicationOptions: [
        { id: 1, name: 'Corticoide' },
        { id: 2, name: 'Mesalazina' },
        { id: 3, name: 'Sulfasalazina' },
        { id: 4, name: 'Imunossupressores' },
        { id: 5, name: 'Imunobiológicos' }
      ],
      yesNoOptions: [
        { id: 1, name: 'Sim' },
        { id: 2, name: 'Não' }
      ],
      interruptionReasonOptions: [
        { id: 1, name: 'Perda de resposta' },
        { id: 2, name: 'Ineficácia' },
        { id: 3, name: 'Intolerância' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getUserToken']),
    ...mapGetters('clinicalCasesEvaluation', ['getVoucher']),
    ...mapGetters('activeClinicalCases', [
      'getLoading',
      'getFile',
      'activeVoucher',
      'getVoucherInfos'
    ]),
    isConsultant() {
      const user = localStorage.getItem('user')
      return user ? JSON.parse(user).type === 'consultant_doctor' : false
    },

    isEdit() {
      if (this.isConsultant === 'consultant_doctor') return false
      if (
        this.getVoucherInfos.length !== 0 &&
        this.getVoucherInfos?.status !== 'aloc'
      )
        return false
      return true
    },
    handleEnabledSubmit() {
      return (
        !this.age ||
        !this.gender ||
        !this.color ||
        !this.weight ||
        !this.height ||
        !this.diag ||
        !this.yearDiag ||
        !this.locationMontreal ||
        !this.behaviorMontreal ||
        !this.extension ||
        !this.mainSymptoms ||
        !this.mainSymptomsDescription ||
        !this.intestinalManifestations ||
        !this.intestinalManifestationsDescription ||
        !this.needCorticoide ||
        !this.neededSurgery ||
        !this.neededSurgeryDescription ||
        !this.treatments ||
        !this.currentTreatment ||
        !this.hasComorbidities ||
        !this.comorbidities ||
        !this.hasMedicationAllergies ||
        !this.mainConsultationReason ||
        !this.firstColonoscopy ||
        !this.colonoscopyDate ||
        !this.colonoscopyFindings ||
        !this.recentColonoscopy ||
        !this.recentColonoscopyDate ||
        !this.recentColonoscopyFindings ||
        !this.oldestColonoscopyDate ||
        !this.oldestColonoscopyFindings ||
        !this.nameExam ||
        !this.imageExamDate
      )
    },
    getColonoscopyFiles() {
      const files = this.getFile.filter((file) => file.type === 'colonoscopy')
      return files
    },
    getOldestColonoscopyFiles() {
      return this.getFile.filter((file) => file.type === 'oldest_colonoscopy')
    },
    getImageExamFiles() {
      return this.getFile.filter((file) => file.type === 'image_exam')
    },
    getRecentColonoscopyFiles() {
      return this.getFile.filter((file) => file.type === 'recent_colonoscopy')
    },
    isLoading() {
      return this.getLoading
    },
    canAddTreatment() {
      return (
        this.selectedMedication &&
        this.startYear &&
        this.initialResponse &&
        this.treatmentInterrupted &&
        (this.treatmentInterrupted === 2 ||
          (this.treatmentInterrupted === 1 && this.interruptionReason))
      )
    }
  },
  methods: {
    ...mapActions('activeClinicalCases', [
      'uploadFile',
      'fechVoucherDownload',
      'fetchFile',
      'saveEditVoucher',
      'postFile'
    ]),
    verifyIsEdit(getVoucherInfos) {
      if (getVoucherInfos?.status === 'ativ') return
      return (this.isEdit = true)
    },
    disableAllFields() {
      this.isFieldsDisabled = true
    },
    enableAllFields() {
      this.isFieldsDisabled = false
    },
    handleData() {
      const questionnaire = this.voucherData.questionnaire
      if (!questionnaire) return

      const jsonString = questionnaire
      const jsonObject = JSON.parse(jsonString.replace(/'/g, '"'))

      // Dados básicos
      this.age = jsonObject?.age
      this.gender = jsonObject?.gender
      this.color = jsonObject?.color
      this.weight = jsonObject?.weight
      this.height = jsonObject?.height
      this.diag = jsonObject?.diag
      this.yearStartSint = jsonObject?.yearStartSint
      this.yearDiag = jsonObject?.yearDiag
      this.locationMontreal = jsonObject?.locationMontreal
      this.behaviorMontreal = jsonObject?.behaviorMontreal
      this.extension = jsonObject?.extension

      // Sintomas e manifestações
      this.mainSymptoms = jsonObject?.mainSymptoms
      this.mainSymptomsDescription = jsonObject?.mainSymptomsDescription
      this.intestinalManifestations = jsonObject?.intestinalManifestations
      this.intestinalManifestationsDescription =
        jsonObject?.intestinalManifestationsDescription

      // Tratamentos e cirurgias
      this.needCorticoide = jsonObject?.needCorticoide
      this.neededSurgery = jsonObject?.neededSurgery
      this.neededSurgeryDescription = jsonObject?.neededSurgeryDescription
      this.treatments = jsonObject?.treatments || []
      this.currentTreatment = jsonObject?.currentTreatment

      // Comorbidades e alergias
      this.hasComorbidities = jsonObject?.hasComorbidities
      this.comorbidities = jsonObject?.comorbidities
      this.hasMedicationAllergies = jsonObject?.hasMedicationAllergies

      // Consulta e exames
      this.mainConsultationReason = jsonObject?.mainConsultationReason
      this.hasProteinaCReativa = jsonObject?.hasProteinaCReativa
      this.hasCalprotectinaFecal = jsonObject?.hasCalprotectinaFecal

      // Colonoscopias
      this.firstColonoscopy = jsonObject?.firstColonoscopy
      this.colonoscopyDate = jsonObject?.colonoscopyDate
      this.colonoscopyFindings = jsonObject?.colonoscopyFindings
      this.recentColonoscopy = jsonObject?.recentColonoscopy
      this.recentColonoscopyDate = jsonObject?.recentColonoscopyDate
      this.recentColonoscopyFindings = jsonObject?.recentColonoscopyFindings
      this.oldestColonoscopyDate = jsonObject?.oldestColonoscopyDate
      this.oldestColonoscopyFindings = jsonObject?.oldestColonoscopyFindings

      // Outros exames
      this.imageExamSelect = jsonObject?.imageExamSelect
      this.nameExam = jsonObject?.nameExam
      this.imageExamDate = jsonObject?.imageExamDate
      this.endoDigestiveHigh = jsonObject?.endoDigestiveHigh

      // Exames complementares
      this.examDates = jsonObject?.examDates || ['', '', '', '']
      this.examHb = jsonObject?.examHb || ['', '', '', '']
      this.examVcm = jsonObject?.examVcm || ['', '', '', '']
      this.examRdw = jsonObject?.examRdw || ['', '', '', '']
      this.examLeucocitos = jsonObject?.examLeucocitos || ['', '', '', '']
      this.examNeutrofilos = jsonObject?.examNeutrofilos || ['', '', '', '']
      this.examLinfocitos = jsonObject?.examLinfocitos || ['', '', '', '']
      this.examEosinofilos = jsonObject?.examEosinofilos || ['', '', '', '']
      this.examPlaquetas = jsonObject?.examPlaquetas || ['', '', '', '']
      this.examProteinaCReativa = jsonObject?.examProteinaCReativa || [
        '',
        '',
        '',
        ''
      ]
      this.examTgo = jsonObject?.examTgo || ['', '', '', '']
      this.examTgp = jsonObject?.examTgp || ['', '', '', '']
      this.examGgt = jsonObject?.examGgt || ['', '', '', '']
      this.examCalprotectinaFecal = jsonObject?.examCalprotectinaFecal || [
        '',
        '',
        '',
        ''
      ]
      this.examCreatinina = jsonObject?.examCreatinina || ['', '', '', '']

      // Observações
      this.observacoes = jsonObject?.observacoes
      this.verifyIsEdit()
    },
    updateFormData(data) {
      // Atualize os campos do formulário com os dados do voucher
      if (data && Object.keys(data).length > 0) {
        // Exemplo: this.age = data.age
        // Atualize todos os campos relevantes aqui
      }
    },
    async handleImageExamFile(file) {
      this.selectedImageExamFile = file.raw
      await this.submitImageExamFilecopy()
    },
    async handleOldestFileImg(file) {
      this.selectedOldestColonoscopyFile = file.raw
      await this.submitOldestColonoscopy()
    },

    async handleFileImg(file, type) {
      this.selectedFile = file.raw
      await this.submit(type)
    },

    async submit(type) {
      const url = process.env.VUE_APP_CLINICAL_CASE_API
      const voucherId = this.voucherData.id
      const formData = new FormData()
      formData.append('body', this.selectedFile)
      formData.append('type', type)

      try {
        await axios.post(`${url}/voucher/${voucherId}/document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.getUserToken}`
          }
        })
        this.toast.success('Upload realizado com sucesso', {
          timeout: 8000
        })
        await this.fetchFile(voucherId)
        this.selectedFile = null
        this.$forceUpdate()
      } catch (error) {
        console.error('Erro ao fazer upload do arquivo:', error)
        this.toast.warning('Não foi possível realizar o upload do arquivo')
      }
    },

    handleDownload(id, name) {
      const fileData = {
        id: id,
        name: name
      }
      this.fechVoucherDownload(fileData)
    },
    addTreatment() {
      if (this.canAddTreatment) {
        const medication = this.medicationOptions.find(
          (m) => m.id === this.selectedMedication
        )
        const initialResponse = this.yesNoOptions.find(
          (o) => o.id === this.initialResponse
        )
        const treatmentInterrupted = this.yesNoOptions.find(
          (o) => o.id === this.treatmentInterrupted
        )
        const interruptionReason = this.interruptionReasonOptions.find(
          (r) => r.id === this.interruptionReason
        )

        this.treatments.push({
          medication: medication.name,
          startYear: this.startYear,
          endYear: this.endYear || 'N/A',
          initialResponse: initialResponse.name,
          treatmentInterrupted: treatmentInterrupted.name,
          interruptionReason: interruptionReason
            ? interruptionReason.name
            : 'N/A'
        })

        // Limpar os campos após adicionar
        this.selectedMedication = null
        this.startYear = null
        this.endYear = null
        this.initialResponse = null
        this.treatmentInterrupted = null
        this.interruptionReason = null
      }
    },
    removeTreatment(index) {
      this.treatments.splice(index, 1)
    },
    salvarFormulario() {
      const userData = {
        data: JSON.stringify({
          examDates: this.examDates,
          examHb: this.examHb,
          examVcm: this.examVcm,
          examRdw: this.examRdw,
          examLeucocitos: this.examLeucocitos,
          examNeutrofilos: this.examNeutrofilos,
          examLinfocitos: this.examLinfocitos,
          examEosinofilos: this.examEosinofilos,
          examPlaquetas: this.examPlaquetas,
          examProteinaCReativa: this.examProteinaCReativa,
          examTgo: this.examTgo,
          examTgp: this.examTgp,
          examGgt: this.examGgt,
          examCalprotectinaFecal: this.examCalprotectinaFecal,
          examCreatinina: this.examCreatinina,
          age: this.age,
          gender: this.gender,
          color: this.color,
          weight: this.weight,
          height: this.height,
          diag: this.diag,
          yearStartSint: this.yearStartSint,
          yearDiag: this.yearDiag,
          locationMontreal: this.locationMontreal,
          behaviorMontreal: this.behaviorMontreal,
          extension: this.extension,
          mainSymptoms: this.mainSymptoms,
          mainSymptomsDescription: this.mainSymptomsDescription,
          intestinalManifestations: this.intestinalManifestations,
          intestinalManifestationsDescription: this
            .intestinalManifestationsDescription,
          needCorticoide: this.needCorticoide,
          neededSurgery: this.neededSurgery,
          neededSurgeryDescription: this.neededSurgeryDescription,
          treatments: this.treatments,
          currentTreatment: this.currentTreatment,
          hasComorbidities: this.hasComorbidities,
          comorbidities: this.comorbidities,
          hasMedicationAllergies: this.hasMedicationAllergies,
          mainConsultationReason: this.mainConsultationReason,
          hasProteinaCReativa: this.hasProteinaCReativa,
          hasCalprotectinaFecal: this.hasCalprotectinaFecal,
          firstColonoscopy: this.firstColonoscopy,
          colonoscopyDate: this.colonoscopyDate,
          colonoscopyFindings: this.colonoscopyFindings,
          recentColonoscopy: this.recentColonoscopy,
          recentColonoscopyDate: this.recentColonoscopyDate,
          recentColonoscopyFindings: this.recentColonoscopyFindings,
          oldestColonoscopyDate: this.oldestColonoscopyDate,
          oldestColonoscopyFindings: this.oldestColonoscopyFindings,
          imageExamSelect: this.imageExamSelect,
          nameExam: this.nameExam,
          imageExamDate: this.imageExamDate,
          endoDigestiveHigh: this.endoDigestiveHigh,
          observacoes: this.observacoes
        }),
        voucherId: this.getVoucher.id
      }

      this.saveEditVoucher(userData)
        .then(() => {
          this.toast.success('Formulário salvo com sucesso', {
            timeout: 2000
          })
        })
        .catch(() => {
          this.toast.error('Erro ao salvar o formulário', {
            timeout: 2000
          })
        })
    },
    handleActiveVoucher() {
      const userData = {
        data: JSON.stringify({
          examDates: this.examDates,
          examHb: this.examHb,
          examVcm: this.examVcm,
          examRdw: this.examRdw,
          examLeucocitos: this.examLeucocitos,
          examNeutrofilos: this.examNeutrofilos,
          examLinfocitos: this.examLinfocitos,
          examEosinofilos: this.examEosinofilos,
          examPlaquetas: this.examPlaquetas,
          examProteinaCReativa: this.examProteinaCReativa,
          examTgo: this.examTgo,
          examTgp: this.examTgp,
          examGgt: this.examGgt,
          examCalprotectinaFecal: this.examCalprotectinaFecal,
          examCreatinina: this.examCreatinina,
          age: this.age,
          gender: this.gender,
          color: this.color,
          weight: this.weight,
          height: this.height,
          diag: this.diag,
          yearStartSint: this.yearStartSint,
          yearDiag: this.yearDiag,
          locationMontreal: this.locationMontreal,
          behaviorMontreal: this.behaviorMontreal,
          extension: this.extension,
          mainSymptoms: this.mainSymptoms,
          mainSymptomsDescription: this.mainSymptomsDescription,
          intestinalManifestations: this.intestinalManifestations,
          intestinalManifestationsDescription: this
            .intestinalManifestationsDescription,
          needCorticoide: this.needCorticoide,
          neededSurgery: this.neededSurgery,
          neededSurgeryDescription: this.neededSurgeryDescription,
          treatments: this.treatments,
          currentTreatment: this.currentTreatment,
          hasComorbidities: this.hasComorbidities,
          comorbidities: this.comorbidities,
          hasMedicationAllergies: this.hasMedicationAllergies,
          mainConsultationReason: this.mainConsultationReason,
          hasProteinaCReativa: this.hasProteinaCReativa,
          hasCalprotectinaFecal: this.hasCalprotectinaFecal,
          firstColonoscopy: this.firstColonoscopy,
          colonoscopyDate: this.colonoscopyDate,
          colonoscopyFindings: this.colonoscopyFindings,
          recentColonoscopy: this.recentColonoscopy,
          recentColonoscopyDate: this.recentColonoscopyDate,
          recentColonoscopyFindings: this.recentColonoscopyFindings,
          oldestColonoscopyDate: this.oldestColonoscopyDate,
          oldestColonoscopyFindings: this.oldestColonoscopyFindings,
          imageExamSelect: this.imageExamSelect,
          nameExam: this.nameExam,
          imageExamDate: this.imageExamDate,
          endoDigestiveHigh: this.endoDigestiveHigh,
          observacoes: this.observacoes
        }),
        voucherId: this.getVoucher.id
      }

      this.activeVoucher(userData)
        .then(() => {
          this.toast.success('Caso clínico submetido com sucesso', {
            timeout: 2000
          })
          this.$router.push({ name: 'ClinicalCases' })
        })
        .catch(() => {
          this.toast.error('Erro ao submeter o caso clínico', {
            timeout: 2000
          })
        })
    }
  },
  watch: {
    getFile: {
      immediate: true
    },
    getVoucherInfos() {
      this.verifyIsEdit(this.getVoucherInfos)
      this.handleData()
    },
    voucherData: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.handleData()
        }
      }
    }
  },
  mounted() {
    this.handleData()
    this.verifyIsEdit(this.getVoucherInfos)
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 20px;
}

#salvar-btn {
  background-color: #009688;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

#salvar-btn:hover {
  background-color: #00796b;
}

.classification-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.classification-btn {
  background-color: white;
  border: 2px solid #009688;
  color: #009688;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30%;
  margin-bottom: 40px;
  font-weight: bold;
}

.classification-btn:hover {
  background-color: #e0f2f1;
}

.icon {
  margin-left: 10px;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;

  .save,
  .send {
    padding: 10px 20px;
    font-size: 16px;
  }

  .send {
    background-color: #409eff;
    border-color: #409eff;
    color: white;

    &:disabled {
      background-color: #a0cfff;
      border-color: #a0cfff;
      color: #ffffff;
    }
  }
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  border-radius: 4px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

#observacoes {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  font-family: Arial, sans-serif;
  font-size: 14px;
}
.exam-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: Arial, sans-serif;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 20px;
}
.exam-table th,
.exam-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.exam-table th:first-child,
.exam-table td:first-child {
  background-color: #f2f2f2;
  width: 20%;
  text-align: center;
}
.exam-table input {
  width: 100%;
  box-sizing: border-box;
  border: none;
  background: transparent;
  padding: 5px;
  text-align: center;
}
.exam-table th,
td {
  font-weight: bold;
}
.title {
  margin-top: 20px;
  margin-bottom: 20px;
  color: $green-500;
}

.line {
  background-color: $green-500;
  margin-top: 15px;
  bottom: -15px;
  width: 60px;
  height: 5px;
}

input-group {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

input-wrapper {
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
}
.clinical-case-upload {
  .filepath {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  .filename {
    cursor: pointer;
    color: #409eff;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
